import Alert from 'common-front/src/designSystem/components/alert';
import { Flex } from 'common/src/designSystem/components/flex';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { Header } from './header';
import { Table } from './table';

export const Roles = () => {
    const translate = useTranslate();

    return (
        <Flex css={{ overflowY: 'auto', padding: '$6 $7' }} direction="column" gap="6" height={1}>
            <Header />
            <Alert.Root>
                <Alert.Titled>
                    <Alert.Title icon="circle-info">
                        {translate('contr_ler_les_p_50104')}
                    </Alert.Title>
                    <Alert.Text>{translate('les_r_les_aiden_19371')}</Alert.Text>
                </Alert.Titled>
            </Alert.Root>
            <Table />
        </Flex>
    );
};
